import Vue from 'vue';


import NoSsr from '@/components/utils/no-ssr';

import * as VueGoogleMaps from 'vue2-google-maps';
import VueYoutube from 'vue-youtube';
import App from './App.vue';

import { createStore } from './store/';
import './assets/styl/main.styl';

const mdpConfig = require('../mdp.config');

const domTemp = document.body.querySelector('#app-wrapper .content');
const articles = domTemp.querySelectorAll('.lc-product');
window.products = {};
for (let i = 0; i < articles.length; i += 1) {
  const id = articles[i].getAttribute('id');
  window.products[id] = {};
  window.products[id].linkElement = articles[i].querySelector('.product-link');
  window.products[id].priceElement = articles[i].querySelector('.product-price');
}
Object.keys(mdpConfig.attributes).forEach((attribute) => {
  window[`___${attribute}`] = domTemp.getAttribute(attribute);
});

const tokens = require('@/assets/tokens/tokens.json');

Vue.prototype.$tokens = Vue.$tokens = tokens; //eslint-disable-line
Vue.component('NoSsr', NoSsr);
Vue.use(VueYoutube);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD7UU8Bua1Wr8dV3Wc0cc96d52be96XC4U',
  },
});

export function createApp(version = 'fr') { // eslint-disable-line
  const store = createStore();
  const app = new Vue({
    store,
    render: h => h(App),
  });

  return { app, store };
}
